import styled from '@emotion/styled';
import { IMatchForAgent } from 'domain/entities/Match/Match';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.locale('ja');

interface MeetingListProps {
    matches: IMatchForAgent[];
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

const Title = styled.h1`
    font-weight: 700;
    font-size: 18px;
`;

const Box = styled.div`
    ${({ isToday }: { isToday: boolean }) => isToday && 'border: 2px solid  #1695D4;'}
    min-width: 260px;
    width: fit-content;
    height: 100px;
    border-radius: 5px;
    font-weight: 700;
    letter-spacing: 0%;
    display: flex;
    padding: 20px;
    align-items: center;
    position: relative;
    background-color: ${({ isToday }: { isToday: boolean }) => (isToday ? '#1695D40D' : '#fff')};
`;

const Detail = styled.div`
    display: flex;
    flex-direction: column;
    text-align: left;
    line-height: 1.5;
    gap: 5px;
`;

const MatchWrapper = styled.div`
    display: flex;
    gap: 40px;
    overflow-x: auto;
    padding: 10px 0;
`;

const TodayBadge = styled.div`
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #fe4500;
    color: white;
    padding: 6px 10px;
    border-radius: 50%;
    font-weight: 700;
    font-size: 14px;
    line-height: 20.72px;
    letter-spacing: 0%;
`;

const MeetingDate = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 16.8px;
    letter-spacing: 0%;
    color: #797979;
`;

const CompanyName = styled.div`
    font-weight: 700;
    font-size: 14px;
    line-height: 21px;
    letter-spacing: 0%;
`;

export const MeetingList: React.FC<MeetingListProps> = ({ matches }) => {
    const today = dayjs().startOf('day');
    return (
        <Wrapper>
            <Title>面談カレンダー</Title>
            <MatchWrapper>
                {matches.length === 0 && <div style={{ paddingLeft: '20px' }}>現在、面談予定はありません</div>}
                {matches.map((match) => (
                    <Box isToday={dayjs(match.meeting_date).isSame(today, 'day')} key={match.id}>
                        {dayjs(match.meeting_date).isSame(today, 'day') && <TodayBadge>本日</TodayBadge>}
                        <Detail>
                            <MeetingDate>{dayjs(match.meeting_date).format('YYYY年M月D日（ddd）HH:mm')}</MeetingDate>
                            <CompanyName>{match.company.name}</CompanyName>
                        </Detail>
                    </Box>
                ))}
            </MatchWrapper>
        </Wrapper>
    );
};
